var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelmet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3795 15.0723H23.1726V27.2102H25.3795V15.0723Z",
    fill: "#B1B0F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69336 13.5469C3.69336 10.283 4.98995 7.15272 7.2979 4.84477C9.60585 2.53683 12.7361 1.24023 16 1.24023C19.264 1.24023 22.3942 2.53683 24.7022 4.84477C27.0101 7.15272 28.3067 10.283 28.3067 13.5469H16L11.0667 18.4802H3.69336V13.5469Z",
    fill: "#8E8CEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1615 20.5894H3.57066C3.209 20.5894 2.86216 20.4448 2.60643 20.1875C2.3507 19.9302 2.20703 19.5813 2.20703 19.2174C2.20703 18.8535 2.3507 18.5046 2.60643 18.2473C2.86216 17.99 3.209 17.8455 3.57066 17.8455H11.0297L15.9797 12.8652H28.4296C28.7913 12.8652 29.1381 13.0098 29.3938 13.2671C29.6496 13.5244 29.7932 13.8733 29.7932 14.2372C29.7932 14.6011 29.6496 14.95 29.3938 15.2073C29.1381 15.4646 28.7913 15.6092 28.4296 15.6092H17.1115L12.1615 20.5894Z",
    fill: "#8E8CEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1381 20.5898H9.93115V30.5209H12.1381V20.5898Z",
    fill: "#B1B0F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2414 26.1074H8.82764V28.3143H13.2414V26.1074Z",
    fill: "#8E8CEE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4829 22.7969H22.0691V25.0038H26.4829V22.7969Z",
    fill: "#8E8CEE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3451 8.45117H7.72437V9.55462H14.3451V8.45117Z",
    fill: "#FCFCFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3451 10.6582H7.72437V11.7617H14.3451V10.6582Z",
    fill: "#FCFCFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3451 9.55469H7.72437V10.6581H14.3451V9.55469Z",
    fill: "#E6E5FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelmet);
export default __webpack_public_path__ + "static/media/helmet.72ae3bdfeae24b932450ff3c67e897f2.svg";
export { ForwardRef as ReactComponent };